import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./Veterinary.css";
import RegistrationModal2 from "../../components/RegistrationModal2";

const Veterinary = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
    });
  }, []);

  return (
    <>
      <section className="services-page">

        {/* Banner */}
        <div className="service-banner">
          <div className="overlay"></div>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <h1>Services</h1>
                <p>Comprehensive veterinary care for your beloved pets</p>
              </div>

              <div className="col-lg-6 text-end">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/imgs/Services_header.png`}
                  alt="Pets"
                  className="img-fluid banner-pets"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Service Card */}
        <div className="service-section">
          <div className="container">

            <div className="service-card">
              <div className="row">
                <div className="col-md-5">
                  <div className="service-content">
                    <h1 className="font-bold mb-4">
                      Veterinary Services
                    </h1>
                    <p className="font-semibold">
                      Comprehensive veterinary care for your beloved pets. Our network of qualified veterinarians provides everything from routine check-ups to emergency medical services.
                    </p>
                    <p>
                      We prioritize your pet's health and wellbeing with compassionate care, modern facilities, and transparent communication with pet owners.
                    </p>
                    <a className="btn btn-dark rounded-pill px-4 w-mxcontent mt-4 font-semibold py-2" data-bs-toggle="modal" data-bs-target="#RegistrationModal2">
                      Join Us Now
                    </a>
                  </div>
                </div>
                <div className="col-md-7 pe-0">
                  <div className="service-image">
                    <img
                       className="img-fluid dog-image"
                      src={`${process.env.PUBLIC_URL}/assets/imgs/service_img/veterinary_services.jpeg`}
                      alt="Veterinary Services"
                    />
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        {/* Registration Modal 2 for Service Providers */}
        <RegistrationModal2 preSelectedService="veterinary" />
      </section>
    </>
  );
};

export default Veterinary;
